module.exports = __webpack_public_path__ + "66ee3ea1e3e6dee9b309a6c88c6ebb31.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/nara-kasbergen.jpg
// module id = 449
// module chunks = 0